import { Component, Input, OnInit } from '@angular/core';
import { TravelEvents } from 'src/app/Models/MisEventos/travelEvents';
import { Coordinate } from 'src/app/Models/MisViajes/Coordinate';

@Component({
  selector: 'app-mapa-eventos',
  templateUrl: './mapa-eventos.component.html',
  styleUrls: ['./mapa-eventos.component.css']
})
export class MapaEventosComponent implements OnInit {

  @Input()
  travelEvents: TravelEvents;

  constructor() { }

  ngOnInit(): void{
  }

}
